/**
 * Created by Ivan on 10.10.2025
 */

const RaveReviewsRewardTutorial = function () {
    return new TutorialScenario("rave_reviews_reward_tutorial", {
        listSteps: () => [
            RaveReviewsTutorial.createIconStep(Forces.RAVE_RAVIEWS_REWARD),
            RaveReviewsRewardTutorial.createClaimStep()
        ],

        isAvailable: function () {
            if (!Merge2.current || cleverapps.forces.isShown(Forces.RAVE_RAVIEWS_REWARD) || !Merge2.current.isGameMode()) {
                return false;
            }

            return cleverapps.raveReviews.isAvailable() && cleverapps.raveReviews.isCompleted();
        }
    });
};

RaveReviewsRewardTutorial.createClaimStep = function () {
    const options = {
        onStart: function () {
            this.force = cleverapps.forces.create(cleverapps.focusManager.currentWindow().button, {}, {
                highlights: [cleverapps.focusManager.currentWindow().wrapper]
            });

            cleverapps.tutorial.on("window_closed", this.finish.bind(this), this);
        },

        onFinish: function () {
            this.force.hideForceHints();
            Merge2.current.counter.trigger();
        }
    };

    return new TutorialStep(options);
};